import { queryOptions } from "@tanstack/react-query"
import type { components } from "@/shared/lib/api.types"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"
import type { StatisticsRange } from "../statistics.config"

export type StatisticsDay = components["schemas"]["StatisticsDayDto"]
export type StatisticsRecommendation = components["schemas"]["StatisticsRecommendationDto"]
export type StatisticsNight = components["schemas"]["StatisticsNightDto"]
export type Statistics = components["schemas"]["StatisticsDto"]

export function statisticsQueryOptions(childId: string, range: StatisticsRange) {
  return queryOptions({
    queryKey: ["statistics", childId, range],
    queryFn: () =>
      unwrap(
        apiClient.GET("/api/children/{childId}/statistics", {
          params: { path: { childId }, query: { range } },
        }),
      ),
  })
}
